/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export enum Keys {
  ArrowLeft = 'ArrowLeft',
  ArrowUp = 'ArrowUp',
  ArrowRight = 'ArrowRight',
  ArrowDown = 'ArrowDown',
  Backspace = 'Backspace',
  Tab = 'Tab',
  Enter = 'Enter',
  Escape = 'Escape',
  Space = 'Space',
  Spacebar = ' ',
  Home = 'Home',
  End = 'End',
}

export enum IEKeys {
  ArrowUp = 'Up',
  ArrowDown = 'Down',
  ArrowRight = 'Right',
  ArrowLeft = 'Left',
  Space = 'Spacebar',
  Escape = 'Esc',
}
